// Action List
export const changeAccessToken = 'CHANGE_ACCESS_TOKEN';
export const logout = 'LOGOUT';
export const changeUserDetail = 'CHANGE_USER_DETAIL';
export const changeLanguage = 'CHANGE_LANGUAGE';
export const setDefaultView = 'SET_DEFAULT_VIEW';
export const changeUserInfo = 'CHANGE_USER_INFO';

const INITIAL_STATE = {
    info: null,
    profile: '',
    profileItems: [],
    accessToken: null,
    language: 'en',
    expiredAt: 0,
};

const ACTION_HANDLERS = {
    [changeAccessToken]: (state, payload) => ({
        ...state,
        accessToken: payload.accessToken,
        expiredAt: payload.expiredAt,
    }),
    [logout]: state => ({
        ...state,
        language: 'en',
        info: null,
        profileItems: [],
        accessToken: null,
        expiredAt: 0,
    }),
    [changeUserInfo]: (state, payload) => ({
        ...state,
        info: payload,
    }),
    [changeUserDetail]: (state, payload) => ({
        ...state,
        info: payload.info,
        profileItems: payload.profileItems,
        profile: payload.profile,
    }),
    [changeLanguage]: (state, payload) => ({
        ...state,
        language: payload,
    }),
    [setDefaultView]: (state, payload) => ({
        ...state,
        info: {
            ...state.info,
            defaultView: payload,
        },
    }),
};

export default (state = INITIAL_STATE, { type, payload }) => {
    const fn = ACTION_HANDLERS[type];
    if (typeof fn === 'function') {
        return fn(state, payload);
    }
    return state;
};
